import { render } from "./DynamicDetails.vue?vue&type=template&id=7ef3e6ff&scoped=true"
import script from "./DynamicDetails.vue?vue&type=script&lang=js"
export * from "./DynamicDetails.vue?vue&type=script&lang=js"

import "./DynamicDetails.vue?vue&type=style&index=0&id=7ef3e6ff&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ef3e6ff"]])

export default __exports__